var urlString = "https://api.shanthijewellers.com/";
// var urlString = "http://localhost:8032/";

const GetApiCall = {
  getRequest(url) {
    // console.log(urlString+url)
    return fetch(urlString + url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
      },
    });
  },
};
export default GetApiCall;
